module.exports = __webpack_public_path__ + "img/equity.48c30d28.png";